import { Grid, Stack } from '@mui/material'
import React from 'react'
// import { useEffect } from 'react'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { BackButton } from '../components/common/buttons/backButton'
import { ButtonL } from '../components/common/buttons/buttonL'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { Form } from '../components/common/inputs/form'
import { FlexibleCheckBoxesUnit } from '../components/common/memberModifyChild/flexibleCheckBoxesUnit'
import { SubTitle } from '../components/common/subTitle'
import { useAction } from '../../containers/memberModifyChildAllergy/memberModifyChildAllergyService'
import { translate } from '../../i18n'

export const MemberModifyChildAllergy = () => {
  const { CATEGORY_KEY, categoryMst, childrenResultCode, formMethods, onSubmit} = useAction()

  // useEffect(() => {
  //   const subscription = formMethods.watch((values, { name, type }) => {
  //     if (name && type === 'change') {
  //       console.log(values)
  //     }
  //   })
  //   return () => subscription.unsubscribe()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  let targetCategory
  if (categoryMst) {
    targetCategory = categoryMst.find((mst) => mst.category === CATEGORY_KEY)
  }
  if (!targetCategory) return (<BackButton />)
  
  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid container item xs={12} md={6} rowSpacing={1}>
            <Grid item xs={12}>
              <SubTitle title={targetCategory.name} />
            </Grid>
            <Grid item xs={0.3}/>
            <Grid item xs={11.7}>
              <FlexibleCheckBoxesUnit
                categoryMst={targetCategory}
                existFlagName="allergyFlag"
              />
            </Grid>
          </Grid>
          <Grid item md={3}></Grid>
        </Grid>

        {!!childrenResultCode && (
          <ErrorMessageCard
            messages={[translate(`memberModifyConfirmationChild.error.childrenResultCode${childrenResultCode}`)]}
          />
        )}

        <BottomButtonGroup>
          <ButtonL fullWidth type="submit">
            {translate('memberModifyConfirmationChild.button.decision')}
          </ButtonL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}